// Component to show offer value and status of the negotiation offer
import React, { useContext, useEffect, useState } from 'react';

import NegotiationButtonVariant from '../../../../../../_shared/constants/negotiationButtonVariant';
import TradeDetails from '../../../../../../_shared/models/TradeDetails';
import convertToCurrency from '../../../../../../_shared/utils/convertToCurrency';

import BidBoxContext from '../../../../BidBoxContainer/BidBoxContext';
import PendingBidBoxFooterContext from '../../PendingBidBoxFooterContainer/PendingBidBoxFooterContext';
import OfferStatusMessage from './OfferStatusMessage';

import {
  OfferNotification,
  OfferValue,
  OfferValueWrapper,
  StyledCurrentOffer
} from './Styles';
import { TradeContext } from '../../../../../../_shared/types/trade';

const CurrentNegotiationOffer = ({ tradeContext }) => {
  const [showOfferNotification, setShowOfferNotification] = useState(false);

  const { tradeDetails } = useContext(BidBoxContext);
  const [latestOffer, setLatestOffer] = useState(
    TradeDetails.getLatestProposalPrice(tradeDetails)
  );
  const { negotiationButtonVariant, negotiations } = useContext(
    PendingBidBoxFooterContext
  );

  useEffect(() => {
    if (negotiationButtonVariant === NegotiationButtonVariant.respond) {
      setShowOfferNotification(true);
      if (negotiations && negotiations?.proposals) {
        setLatestOffer(
          negotiations.proposals[negotiations.proposals.length - 1]?.price
        );
      }
    }
  }, [negotiationButtonVariant, negotiations]);

  if (
    ![NegotiationButtonVariant.respond, NegotiationButtonVariant.view].includes(
      negotiationButtonVariant
    )
  ) {
    return null;
  }

  return (
    <StyledCurrentOffer isSelling={tradeContext === TradeContext.Sell}>
      <OfferStatusMessage tradeContext={tradeContext} />
      <OfferValueWrapper>
        {showOfferNotification && <OfferNotification />}
        <OfferValue>{convertToCurrency(latestOffer)}</OfferValue>
      </OfferValueWrapper>
    </StyledCurrentOffer>
  );
};

export default CurrentNegotiationOffer;
